import { BrowserRouter as Router, Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';
import Home from './components/Home';
import Navbar from './components/Navbar';
import './index.css';
import Products from './components/Products';
import Pricing from './components/Pricing';
import About from "./components/About"
import Login from './components/Login';
import PageNotFound from './components/PageNotFound';

function App() {
  return (
    <Router>
    <div className="App">
        <Switch>
            <Route exact path="/fadshop">
              <Navbar />
                <Home />
            </Route>

            <Route path="/fadshop/products">
              <Navbar />
              <Products />
            </Route>

            <Route path="/fadshop/pricing">
                <Navbar />

              <Pricing />
            </Route>

            <Route path="/fadshop/about">
                  <Navbar />

             <About />
            </Route>

            <Route path="/fadshop/login">
                  <Navbar />
              <Login />
            </Route>

            <Route path="*">
                <Navbar />
              <PageNotFound />
            </Route>
        </Switch>
    </div>
    </Router>
  );
}

export default App;